import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

/**
 * Portal authentication hook
 * Provides auth utilities for the investor portal
 */
export function usePortalAuth() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const logout = () => {
    // Clear all investor portal tokens and data from localStorage
    localStorage.removeItem('investor_portal_token');
    localStorage.removeItem('investor_portal_refresh_token');
    localStorage.removeItem('investor_portal_token_expires_at');
    localStorage.removeItem('investor_portal_contact');
    queryClient.clear();
    // Redirect to portal login page
    navigate('/portal/login');
  };

  const isAuthenticated = !!localStorage.getItem('investor_portal_token');

  return {
    logout,
    isAuthenticated,
  };
}
